export const enNoWorkspaceAccessTranslations = {
  noWorkspaceAccess: {
    orgLabel: '{{orgName}}',
    title: 'Welcome to OneStep!',
    body: "Your account is all set — but you're not assigned to a facility yet. An administrator at your organization will add you, and you'll have access as soon as they do.",
    nudge:
      "Need it sooner? Reach out to your organization's <bold>OneStep admin</bold> — they can assign you right away.",
    logout: 'Log out',
  },
};
